import { isNil } from 'lodash-es';

/**
 * Returns a trimmed versions of the input and removes all duplicated whitespaces
 *
 * @param input -
 */
export function normalize(input?: string): string {
  if (isNil(input)) {
    return '';
  }

  const stringValue = String(input);
  return stringValue.trim().replace(/\s+/g, ' ');
}
